import { combineReducers } from 'redux';

import { searchInsuranceRequirements } from '../api/portal-api';

import { withCertificateBlueprint } from './blueprints/certificate-creation';
import { withRequirementTemplateBlueprint } from './blueprints/requirement-templates';
import { withSearchBlueprint } from './blueprints/search';
import { reducer as activityLogReducer } from './modules/activityLog';
import adminPageReducer from './modules/adminPage';
import agentPortalReducer from './modules/agentPortal';
import alertModalReducer from './modules/alertModal';
import appReducer from './modules/app';
import companyReducer from './modules/company';
import createPasswordReducer from './modules/createPassword';
import departmentReducer from './modules/department';
import documentReducer from './modules/documents';
import emailAutomations from './modules/emailAutomations';
import emailReducer from './modules/emails';
import errorReducer from './modules/error';
import formReducer from './modules/form';
import insuranceRequirementReducer from './modules/insuranceRequirements';
import insuredReducer from './modules/insured';
import { reducer as insuredListReducer } from './modules/insuredList';
import insuredProfilePageReducer from './modules/insuredProfilePage';
import { reducer as insuredsReducer } from './modules/insureds';
import { reducer as itemsReducer } from './modules/items';
import jobsReducer from './modules/jobs';
import { reducer as jobSearchReducer } from './modules/jobSearch';
import maintenanceReducer from './modules/maintenance';
import modalReducer from './modules/modal';
import navbarReducer from './modules/navbar';
import procoreSidePanelReducer from './modules/procoreSidePanel';
import reportsReducer from './modules/reports';
import trayReducer from './modules/tray';
import userReducer from './modules/user';

export const insuredCertificateCreator = withCertificateBlueprint('insuredCertificates', null, {});
export const agentCertificateCreator = withCertificateBlueprint('agentCertificates', null, {});

export const globalRequirementTemplateBuilder = withRequirementTemplateBlueprint('globalRequirementTemplateBuilder', {
  leftTabTypeOption: 'createRequirementsTemplatesLeft',
  rightTabTypeOption: 'createRequirementsTemplatesRight'
});

export const insuredRequirementTemplateBuilder = withRequirementTemplateBlueprint('insuredRequirementTemplateBuilder', {
  leftTabTypeOption: 'createInsuredRequirementsLeft',
  rightTabTypeOption: 'createInsuredRequirementsRight',
  saveButtonOptions: { text: 'Save Requirements', type: 'create-requirements' },
  showSideHeaders: false,
  builderHeight: '95%',
  sidePanelHeight: '92%'
});

export const jobDetailsSearch = withSearchBlueprint('jobDetailsSearch', null, {
  endpoint: searchInsuranceRequirements,
  defaultSort: [{ id: 'insured', desc: false }],
  globalSearchIndices: [
    'insured.company_name',
    'insured.email',
    'insurance_requirement.contract_number'
  ],
  lengthAwarePagination: true,
  aggregates: false
});

export default combineReducers({
  activityLog: activityLogReducer,
  adminPage: adminPageReducer,
  agentCertificates: agentCertificateCreator.reducer,
  agentPortal: agentPortalReducer,
  alert: alertModalReducer,
  app: appReducer,
  company: companyReducer,
  createPassword: createPasswordReducer,
  department: departmentReducer,
  documents: documentReducer,
  emails: emailReducer,
  error: errorReducer,
  form: formReducer,
  globalRequirementTemplateBuilder: globalRequirementTemplateBuilder.reducer,
  insured: insuredReducer,
  insuredCertificates: insuredCertificateCreator.reducer,
  insuredList: insuredListReducer,
  insuredRequirementTemplateBuilder: insuredRequirementTemplateBuilder.reducer,
  insureds: insuredsReducer,
  insuredProfilePage: insuredProfilePageReducer,
  items: itemsReducer,
  jobDetailsSearch: jobDetailsSearch.reducer,
  jobSearch: jobSearchReducer,
  jobs: jobsReducer,
  maintenance: maintenanceReducer,
  modal: modalReducer,
  navbar: navbarReducer,
  reports: reportsReducer,
  tray: trayReducer,
  user: userReducer,
  insuranceRequirements: insuranceRequirementReducer,
  emailAutomations,
  procoreSidePanel: procoreSidePanelReducer
});
